import { AppState, LoginWithIdPOptions } from "../idp-auth";
import { NavigateOptions, RedirectLoginOptions } from "./context";

/**
 * Convert RedirectLoginOptions to LoginWithIdPOptions
 * @param opts
 * @constructor
 */
export function redirectLoginToIdPOptions(opts: RedirectLoginOptions): LoginWithIdPOptions {
  const { username, loginType, ...idpOptions } = opts;
  return {
    ...idpOptions,
    email: username,
  };
}

/**
 * Convert NavigateOptions to RedirectLoginOptions
 */
export function navigateToRedirectLoginOptions(
  loginType: string,
  opts: NavigateOptions
): RedirectLoginOptions {
  const { identifier, ...redirectOptions } = opts;
  return {
    ...redirectOptions,
    username: identifier,
    loginType,
  };
}

/**
 * The interactive login that follows a failed silent attempt, with the same app state.
 */
export function appStateToInteractiveLoginOptions(appState: AppState): LoginWithIdPOptions {
  return {
    token: appState.token,
    screen_hint: appState.screenHint,
    fromUnifiedAccountLink: appState.fromUnifiedAccountLink,
    fromUnifiedAccountSwitching: appState.fromUnifiedAccountSwitching,
    fromReseller: appState.fromReseller,
  };
}
